import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { updatePreferredStore, sendText } from '../../../../../graphql/mutation';
import StoreDetails from './StoreDetails';

const TRY_LATER = 'Please try again after some time';

function StoreDetailsVM({ onSelectStore, ...props }) {
  const [setPreferredStore, { data }] = useMutation(updatePreferredStore);
  const [sendTextMessage] = useMutation(sendText);
  const [error, setError] = useState('');

  const onSetPreferredStore = (customerStore) => {
    const variables = { variables: { storeNumber: customerStore?.storeNumber } };
    setPreferredStore(variables).then(() => {
      if (onSelectStore) onSelectStore(customerStore);
    }).catch((e) => {
      setError(TRY_LATER);
      if (window.trackJs) {
        // log to TrackJS
        window.trackJs.console.error({
          note: 'StoreDetailsVM onSetPreferredStore() encountered an error',
          error: e,
        });
      }
    });
  };

  const onSendTextMessage = (variables) => {
    sendTextMessage({ variables }).catch((e) => {
      setError(TRY_LATER);
      if (window.trackJs) {
        // log to TrackJS
        window.trackJs.console.error({
          note: 'StoreDetailsVM onSendTextMessage() encountered an error',
          error: e,
        });
      }
    });
  };

  const mapProps = {
    ...props,
    error,
    setPreferredStoreStatus: !!data?.updatePreferredStore?.storeNumber,
    onSetPreferredStore,
    onSendTextMessage,
  };

  return <StoreDetails {...mapProps} />;
}

StoreDetailsVM.propTypes = {
  onSelectStore: PropTypes.func,
};

StoreDetailsVM.defaultProps = {
  onSelectStore: null,
};

export default StoreDetailsVM;
